import axios from '../lib/axios'
import { buildUrlString } from '@!/Util'

export const getRankingApi = async (safeSearch, rankingType, page, fetchType) => {
  const url = buildUrlString(`/api/v1/rankings`, { safe_search: safeSearch, ranking_type: rankingType, page, fetch_type: fetchType })
  return await axios.get(url)
}

export const getTopRankingsApi = async (safeSearch, genreTabName) => {
  const params = {
    safe_search: safeSearch,
  }

  if (genreTabName) {
    params.genre_tab_name = genreTabName
  }

  const url = buildUrlString('/api/v1/rankings/top', params)
  return await axios.get(url)
}
